// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kky7w","text":"styles_text__kU+b2"};